import { render, staticRenderFns } from "./BomCompositeList.vue?vue&type=template&id=32992244"
import script from "./BomCompositeList.vue?vue&type=script&lang=js"
export * from "./BomCompositeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports